import { Text } from "@/components/ui/baseUi/text"
import { cn } from "@/modules/lib/utils"
import { Loader, PlusIcon } from "lucide-react"

export function FileUploadDragZone({
  disabled,
  title,
  description,
  isLoading,
}: {
  disabled?: boolean
  title: string
  description: string
  isLoading?: boolean
}) {
  return (
    <div
      className={cn(
        "group flex h-full flex-col items-center justify-center gap-2 bg-neutral-100 transition-all duration-200 hover:bg-primary-100",
        !disabled && "cursor-pointer",
        disabled && "pointer-events-none",
      )}
    >
      <div
        className="flex items-center justify-center rounded-full bg-neutral-50 transition-all duration-200 group-hover:bg-primary-600"
        style={{
          height: 48,
          width: 48,
        }}
      >
        {isLoading ? (
          <Loader className="animate-spin" />
        ) : (
          <PlusIcon size={24} className="text-neutral-500 transition-all duration-200 group-hover:text-primary-300" />
        )}
      </div>
      <Text
        fontStyle="LL"
        className="text-center text-neutral-500 transition-all duration-200 group-hover:text-primary-600"
      >
        {title}
      </Text>
      <Text
        fontStyle="BS"
        className="px-3 text-center text-neutral-400 transition-all duration-200 group-hover:text-primary-700"
        style={{ whiteSpace: "pre-line" }}
      >
        {description}
      </Text>
    </div>
  )
}
